import { render } from "./AddTopic.vue?vue&type=template&id=848d9d90&scoped=true"
import script from "./AddTopic.vue?vue&type=script&lang=js"
export * from "./AddTopic.vue?vue&type=script&lang=js"

import "./AddTopic.vue?vue&type=style&index=0&id=848d9d90&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-848d9d90"]])

export default __exports__